import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdownMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m608-408 78-78q10-10 5-22t-19-12H488q-14 0-19 12t5 22l78 78q12 12 28 12t28-12Zm-128-72ZM320-200q-117 0-198.5-81.5T40-480q0-117 81.5-198.5T320-760h320q117 0 198.5 81.5T920-480q0 117-81.5 198.5T640-200H320Zm0-80h320q83 0 141.5-58.5T840-480q0-83-58.5-141.5T640-680H320q-83 0-141.5 58.5T120-480q0 83 58.5 141.5T320-280Z" })
});
export default SvgDropdownMenu;
